import { useState } from 'react';
import { Box, Container, Snackbar, Alert } from '@mui/material';
import Header from './components/Header';
import Footer from './components/Footer';
import FeedbackForm, { FormData } from './components/FeedbackForm';

interface Notification {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'info';
}

export default function App() {
  const [notification, setNotification] = useState<Notification>({
    open: false,
    message: '',
    severity: 'info'
  });

  const handleSubmit = async (data: FormData) => {
    const response = await fetch('/api/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || !result.success) {
      const message =
        result?.error ||
        (response.status === 403
          ? 'Your network is not authorized to send requests.'
          : `Request failed (${response.status})`);
      throw new Error(message);
    }

    setNotification({
      open: true,
      message: `Feedback request sent to ${data.email}`,
      severity: 'success'
    });
  };

  return (
    <Box className="app-container">
      <Header />
      <Box className="app-content">
        <Container className="form-container">
          <FeedbackForm onSubmit={handleSubmit} />
        </Container>
      </Box>
      <Footer />
      <Snackbar
        open={notification.open}
        autoHideDuration={5000}
        onClose={() => setNotification((n) => ({ ...n, open: false }))}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity={notification.severity}
          onClose={() => setNotification((n) => ({ ...n, open: false }))}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}
